import { Dropdown } from "semantic-ui-react";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import EditAppendixForm from "./EditAppendixForm";

export default function EditAppendixDropdownItem({ appendix }) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	return (
		<>
			<Dropdown.Item text={t("edit", "Edit")} onClick={() => setOpen(true)} />

			{open && <EditAppendixForm appendix={appendix} onClose={() => setOpen(false)} />}
		</>
	);
}
